
<modal-window :main-width="9">
  <h2>Select Category</h2>
  <p>Select a category for this template or leave empty for uncategorized.</p>

  <div class="form-group">
    <label>Category</label>
    <select class="form-control" v-model="selectedCategoryGuid">
      <option :value="null">-- No Category --</option>
      <option v-for="cat in categories" :key="cat.guid" :value="cat.guid">
        {{ cat.name }}
      </option>
    </select>
  </div>

  <template #sidebar>
    <div class="d-flex flex-column justify-content-end h-100">
      <div class="label mb-2">
        <button class="btn btn-block btn-sm btn-info" @click="close">
          <i class="far fa-times"></i>
          Cancel
        </button>
      </div>
      <div class="label mb-2">
        <button class="btn btn-block btn-sm btn-success" @click="saveAndClose">
          <i class="far fa-save"></i>
          Save and close
        </button>
      </div>
    </div>
  </template>
</modal-window>
